<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="modal-form-rank">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Remitos por Rango</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12 mb-2">
                <div class="form-group">
                  <label for="digito_verificacion">Dígito Verificación</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    id="digito_verificacion"
                    placeholder="Dígito Verificación"
                    v-model="form.digito_verificacion"
                    maxlength="2"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="numero_inf">Num. de Remito Inferior</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    id="numero_inf"
                    placeholder="Numero Inferior"
                    v-model.number="form.numero_inf"
                    :class="
                      $v.form.numero_inf.$invalid ? 'is-invalid' : 'is-valid'
                    "
                    min="1"
                  />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group">
                  <label for="numero_sup">Num. de Remito Superior</label>
                  <input
                    type="number"
                    class="form-control form-control-sm"
                    id="numero_sup"
                    placeholder="Numero Superior"
                    v-model.number="form.numero_sup"
                    :class="
                      $v.form.numero_sup.$invalid ? 'is-invalid' : 'is-valid'
                    "
                    min="1"
                  />
                </div>
              </div>
              <div class="col-lg-6 mt-2">
                <div class="form-group">
                  <label for="numero_sup">Tipo Empresa</label>
                  <select
                    class="form-control form-control-sm"
                    v-model="form.tipo_empresa"
                  >
                    <option value>Seleccione...</option>
                    <option
                      v-for="tipoEmpresa in tipoEmpresas"
                      :key="tipoEmpresa.numeracion"
                      :value="tipoEmpresa.numeracion"
                    >
                      {{ tipoEmpresa.descripcion }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-6 mt-2">
                <div class="form-group">
                  <label for="sitio_id">Isla</label>
                  <v-select
                    :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                    v-model="form.sitio_id"
                    :reduce="(isla) => isla.id"
                    label="nombre"
                    :options="islas"
                    placeholder="Isla"
                    @search="buscarIslas"
                  ></v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button
              type="button"
              class="btn btn-primary"
              v-show="!$v.form.$invalid"
              @click="saveRemitos()"
            >
              Crear Remitos
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import { required } from "vuelidate/lib/validators";

export default {
  name: "RemitoRangos",
  components: {
    vSelect,
  },
  data() {
    return {
      form: {
        digito_verificacion: null,
        numero_inf: null,
        numero_sup: null,
        tipo_empresa: null,
        sitio_id: null,
      },
      islas: [],
    };
  },
  computed: {
    tipoEmpresas() {
      return this.$parent.listasForms.tipoEmpresas || [];
    },
  },
  validations: {
    form: {
      numero_inf: {
        required,
      },
      numero_sup: {
        required,
      },
    },
  },
  methods: {
    limpiarForm() {
      this.islas = [];
      this.form = {
        digito_verificacion: null,
        numero_inf: null,
        numero_sup: null,
        tipo_empresa: null,
        sitio_id: null,
      };
    },

    saveRemitos() {
      // Validar que los campos estén completos
      if (!this.form.numero_inf || !this.form.numero_sup) {
        this.$swal({
          icon: "warning",
          title: "Por favor complete todos los campos requeridos",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      if (this.form.numero_sup < this.form.numero_inf) {
        this.$swal({
          icon: "warning",
          title: "El número superior debe ser mayor o igual al número inferior",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
        return;
      }

      let me = this;
      this.$parent.cargando = true;
      axios
        .post("/api/argentina/remitos", this.form)
        .then(async (response) => {
          this.$parent.cargando = false;
          this.$refs.closeModal.click();
          await this.$parent.getIndex();
          await this.$parent.getGrafica();
          this.limpiarForm();
          this.$swal({
            icon: "success",
            title:
              response.data.msg || "Los remitos se crearon exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.$parent.cargando = false;
          let res = Object.assign({}, e);
          let errorMsg = "Ocurrió un error, vuelva a intentarlo...";

          // Manejar errores de validación
          if (res.response?.data?.errors) {
            const errors = Object.values(res.response.data.errors).flat();
            errorMsg = errors.join(", ");
          } else if (res.response?.data?.msg) {
            errorMsg = res.response.data.msg;
          } else if (res.response?.data?.message) {
            errorMsg = res.response.data.message;
          }

          this.$swal({
            icon: "error",
            title: errorMsg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },

    buscarIslas(search, loading) {
      if (search != "") {
        let self = this;
        loading(true);
        var url = "/api/argentina/sitios/lista?nombre=" + search;
        axios
          .get(url, {
            params: {
              pais_id: 3,
            },
          })
          .then((response) => {
            self.islas = response.data;
            loading(false);
          })
          .catch((error) => {
            self.$swal({
              icon: "error",
              title: "Ocurrió un error" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },
  },
};
</script>
